function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { safeSelect } from '@sie/web-common-utils';
import classNames from '../utils/classNames';
import findAndDecorateWithProps from '../utils/findAndDecorateWithProps';
import Button from '../Button';
import Link from '../Link';

var HeroDetail = /*#__PURE__*/function (_PureComponent) {
  _inherits(HeroDetail, _PureComponent);

  var _super = _createSuper(HeroDetail);

  function HeroDetail() {
    _classCallCheck(this, HeroDetail);

    return _super.apply(this, arguments);
  }

  _createClass(HeroDetail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          title = _this$props.title,
          body = _this$props.body,
          cta = _this$props.cta,
          textComponentId = _this$props.textComponentId,
          titleComponentId = _this$props.titleComponentId;
      var ariaDescribedBy = [];
      var titleUniqueId = "hero-".concat(titleComponentId, "-title");
      var bodyUniqueId = "hero-".concat(textComponentId, "-body");

      if (title) {
        ariaDescribedBy.push(titleUniqueId);
      }

      if (body) {
        ariaDescribedBy.push(bodyUniqueId);
      }

      var ariaDescribedByProp = ariaDescribedBy.length ? ariaDescribedBy.join(' ') : null;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-section', 'psw-l-line-repel-top', 'psw-l-line-wrap@below-tablet-s', 'psw-p-y-7', 'psw-p-y-5@below-tablet-s')
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-stack-left', 'psw-l-space-y-7', 'psw-l-w-1/1@mobile-s', 'psw-l-w-1/1@mobile-l')
      }, title && /*#__PURE__*/React.createElement("h2", _extends({}, titleUniqueId ? {
        id: titleUniqueId
      } : {}, {
        "data-qa": "".concat(qa, "#title"),
        className: "psw-t-title-m psw-m-b-2@below-tablet-s"
      }), title), body && /*#__PURE__*/React.createElement("p", _extends({}, bodyUniqueId ? {
        id: bodyUniqueId
      } : {}, {
        className: classNames('psw-t-subtitle', 'psw-c-t-2', 'psw-m-b-5@below-tablet-s'),
        "data-qa": "".concat(qa, "#body")
      }), body)), /*#__PURE__*/React.createElement("div", {
        className: classNames('psw-l-w-1/1@mobile-l', 'psw-m-l-7', 'psw-m-0@below-tablet-s', {
          'psw-m-sub-t-2': !!title
        })
      }, findAndDecorateWithProps(cta, {
        'aria-describedby': ariaDescribedByProp,
        qa: "".concat(qa, "#cta"),
        ctaType: 'primary',
        variant: 'solid'
      }, function (component) {
        var type = safeSelect(component, 'type');
        return type === Button || type === Link;
      }, {
        limitOneChild: true
      })));
    }
  }]);

  return HeroDetail;
}(PureComponent);

HeroDetail.defaultProps = {
  qa: 'heroDetail',
  title: '',
  body: '',
  textComponentId: '',
  titleComponentId: ''
};
HeroDetail.propTypes = {
  qa: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  body: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  cta: PropTypes.element.isRequired,
  textComponentId: PropTypes.string,
  titleComponentId: PropTypes.string
};
export default HeroDetail;